export default "__VITE_ASSET__DnD6aUs$__"